class ContentModal {
  constructor() {
    this.modal = document.querySelector('[data-content-modal]');
    this.contentContainer = this.modal?.querySelector('[data-content-modal-content]');
    this.overlay = document.querySelector('[data-content-modal-overlay]');
    this.closeBtn = document.querySelector('[data-content-modal-close]');
    this.isOpen = false;

    this.trigger = Array.from(document.querySelectorAll('[data-content-modal-trigger]'));

    this.init();
  }

  init() {
    this.overlay.addEventListener('click', () => this.close());
    this.closeBtn.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    if (this.trigger.length) {
      this.trigger.forEach((trigger) => {
        trigger.addEventListener('click', () => this.open(trigger));
      });
    }
  }

  open(trigger) {
    if (!trigger || !this.modal || !this.contentContainer) return;

    const pageHandle = trigger.getAttribute('data-page-handle');
    const useStaticContent = trigger.getAttribute('data-use-static-content');
    const staticContent = trigger.parentElement.querySelector('[data-static-content]');
    const type = trigger.getAttribute('data-content-modal-type');

    if (type) {
      this.modal.classList.remove('content-modal--popup', 'content-modal--drawer');
      this.modal.classList.add(`content-modal--${type}`);
    } else {
      this.modal.classList.remove('content-modal--popup');
      this.modal.classList.add('content-modal--drawer');
    }

    this.closeBtn.focus();
    this.trapFocus();

    // Only open modal after content is successfully fetched
    if (pageHandle) {
      this.fetchPageContent(pageHandle, () => {
        this.modal.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
        this.isOpen = true;
      });
    } else if (useStaticContent) {
      if (!staticContent) return;

      this.setContent(staticContent.innerHTML);
      this.setPageTitle(trigger.getAttribute('data-page-title'));
      this.contentContainer.classList.add('static-content');
      this.modal.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      this.isOpen = true;
    } else {
      console.error('Could not find page handle or content for content modal.');
      return;
    }
  }

  close() {
    if (!this.modal || !this.contentContainer) return;

    this.modal.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    this.contentContainer.classList.remove('static-content');
    this.isOpen = false;
  }

  trapFocus() {
    const focusableElements = this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    this.modal.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    });
  }

  setContent(content) {
    if (!this.contentContainer) return;
    this.contentContainer.innerHTML = content;
  }

  fetchPageContent(pageHandle, callback) {
    fetch(`/pages/${pageHandle}.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setContent(data.page.body_html);
        this.setPageTitle(data.page.title);

        if (callback && typeof callback === 'function') {
          callback();
        }
      })
      .catch((error) => {
        console.error('Error fetching page content:', error);
        this.setContent('<p>Sorry, there was an error loading the content.</p>');

        if (callback && typeof callback === 'function') {
          callback();
        }
      });
  }

  setPageTitle(title) {
    const pageTitle = this.modal.querySelector('[data-content-modal-title]');
    if (pageTitle && title) {
      pageTitle.textContent = title;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const contentModal = new ContentModal();

  window.eHS.contentModal = contentModal;
});
